// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wR3eZWNrk6kdZB {
  color: var(--ds-text, #172b4d);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  width: 100%;
  max-width: 250px;
  margin-bottom: 12px;
}
.wR3eZWNrk6kdZB:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.wR3eZWNrk6kdZB:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.wR3eZWNrk6kdZB:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.wR3eZWNrk6kdZB[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.wR3eZWNrk6kdZB.o1FfM3WFtT5VQB {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.wR3eZWNrk6kdZB.o1FfM3WFtT5VQB:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.wR3eZWNrk6kdZB.o1FfM3WFtT5VQB:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.wR3eZWNrk6kdZB.nrFvuKIe_g0RsT {
  width: 100%;
}
.wR3eZWNrk6kdZB::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.wR3eZWNrk6kdZB::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.wR3eZWNrk6kdZB:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.wR3eZWNrk6kdZB:focus {
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchInput": `wR3eZWNrk6kdZB`,
	"input-error": `o1FfM3WFtT5VQB`,
	"full": `nrFvuKIe_g0RsT`
};
export default ___CSS_LOADER_EXPORT___;
